define('components/decorators/auto-truncate-menu',[
    'jquery',
    '../util/tool-menu'
],function($, toolMenu){

    $.extend(companyInfo.decorators,{

        "auto-truncate-menu": function(e){

            var menu = $(this);
            var items = getItems( menu );
            var extraMenu = menu.parent().find(".side");

            menu.data('more-container',$('<li class="truncated"><a href="#meer" data-handler="tool-menu" data-at-element=".ico"><span>'+companyInfo.labels.more+'</span><i class="ico ico-end ico-caret-down"></i></a></li>'));

            truncateMenu( menu, items, extraMenu );

            var resizeTimeout;
            $(window).on('resize',function(){
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function(){
                    truncateMenu(menu, items, extraMenu);
                },50);
            });

        }

    });

    function getItems( menu ){
        var items = [];
        menu.find("> li").each(function(){
            items.push({
                width: $(this).outerWidth(true),
                el: this
            });
        });
        return items;
    }

    var MORE_BUTTON_WIDTH = 60;

    function truncateMenu(menu, items, extraMenu){

        var availableWidth = menu.width();
        if(extraMenu.length){  //if there is a right menu, then remove the width of that menu
            availableWidth -= $(extraMenu[0]).outerWidth(true);
        }
        var takenWidth = 0;
        var remaining = [];
        var item, projectedWidth;
        var more = menu.data('more-container');

        more.remove();
        items = items.concat(); // don't destroy original list.

        while( items.length ) {

            item = items.shift();
            projectedWidth = takenWidth + item.width;

            if ( projectedWidth < availableWidth
                && !items.length
                || availableWidth - projectedWidth > MORE_BUTTON_WIDTH) {
                menu.append( item.el );
                takenWidth = takenWidth + item.width;
            } else {
                items.unshift(item);
                break;
            }

        }

        if ( items.length ) {
            var fragment = document.createElement("div");
            var list = $("<ul style=\"list-style:none;\"/>");
            list.append( $.map(items,function(item){return item.el; }) );
            $('<span class="title">'+companyInfo.labels.more+'</span>').appendTo(fragment);
            list.appendTo(fragment);
            more.find('.ico').data('tooltip-content', fragment);
            menu.append(more);
        }

    }

});

